export default __webpack_public_path__ + "locales/lv/OAuth.json?hash=92086fef0b3fc65279693f9bc4376053";